import { render } from "./QualityControlTab.vue?vue&type=template&id=efcf3b38"
import script from "./QualityControlTab.vue?vue&type=script&lang=js"
export * from "./QualityControlTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__